import { Card, Tag, Timeline, Space, Typography, Divider } from 'antd';
import { CloudUploadOutlined, UserOutlined, CalendarOutlined } from '@ant-design/icons';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import DrawerSG from '../../design/Drawer/DrawerSG';
import { defaultFormat } from '../../../../common/utils/formatDate';
import './logsDrawer.sass';

const { Text } = Typography;

export default function PriceLogDrawer(props: {
    visible: boolean,
    onClose: any,
    nameLog?: string,
    wordPressId?: number | string,
    webId?: string,
}) {
    const { data: priceData = [] } = useFetch(
        `${process.env.REACT_APP_API}/priceLogs?wordPressId=${props.wordPressId}&webName=${props.webId}`,
        {},
        []
    );

    const listItems = priceData.map((d: any) => (
        <Timeline.Item 
            key={d.created} 
            dot={<CloudUploadOutlined style={{ fontSize: '16px', color: '#1890ff' }} />}
        >
            <Card 
                size="small" 
                hoverable
                style={{ borderRadius: "8px", borderLeft: "4px solid #1890ff", marginBottom: '8px' }}
            >
                {/* Header de la Card: Fecha y Usuario */}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', alignItems: 'center' }}>
                    <Space>
                        <CalendarOutlined style={{ color: '#8c8c8c' }} />
                        <Text type="secondary" strong style={{ fontSize: '12px' }}>
                            {defaultFormat(d.created)}
                        </Text>
                    </Space>
                    <Tag icon={<UserOutlined />} color="blue" style={{ borderRadius: '4px', margin: 0 }}>
                        {d.userId}
                    </Tag>
                </div>

                {/* Cuerpo: Precios con Iconos */}
                <div style={{ paddingLeft: '4px' }}>
                    {d.salePrice !== d.regularPrice ? (
                        <Space direction="vertical" size={0}>
                            <Space>                                
                                <Text delete type="secondary">Regular: {d.regularPrice.toFixed(2)}€</Text>
                            </Space>
                            <Space>                                
                                <Text strong>Oferta: {d.salePrice.toFixed(2)}€</Text>
                                <Tag color="green" style={{ fontSize: '10px' }}>REBAJADO</Tag>
                            </Space>
                        </Space>
                    ) : (
                        <Space>                            
                            <Text strong>Regular: {d.regularPrice.toFixed(2)}€</Text>
                        </Space>
                    )}
                </div>
            </Card>
        </Timeline.Item>
    ));

    return (
        <DrawerSG 
            title={
                <Space>
                    <span>Historial de Precios: {props.nameLog}</span>
                </Space>
            } 
            visible={props.visible} 
            onClose={props.onClose} 
            placement='right' 
            width={600}
        >
            <div style={{ padding: '10px 5px' }}>
                <Timeline mode="left">
                    {listItems}
                </Timeline>
            </div>
        </DrawerSG>
    );
}